import { Title } from "@justhome/react-ui";
import { FC, PropsWithChildren } from "react";
import { useTranslation } from "../../lib/hooks/useTranslations";

interface ApplicationStepHeaderProps {
  config: any;
  value: any;
  currentStepNumber: number;
}

const ApplicationStepHeader: FC<
  PropsWithChildren<ApplicationStepHeaderProps>
> = ({ config, currentStepNumber, value, children }) => {
  const { t } = useTranslation();
  const title =
    typeof config.title === "function" ? config.title(value) : config.title;
  const description =
    typeof config.description === "function"
      ? config.description(value)
      : config.description;

  return (
    <div className="mb-3m">
      {(title || description) && (
        <span className="text-overline-1-serif mb-2xs text-primary-800">
          {t("step", { step: currentStepNumber.toString() })}
        </span>
      )}

      {title && <Title className="text-h1">{title}</Title>}
      {description && <div className="mt-3xs">{description}</div>}
      {children}
    </div>
  );
};

export default ApplicationStepHeader;
